jQuery(document).ready(function ($) {
    $('#erawan-registration-form').on('submit', function (e) {
        e.preventDefault();

        $('.error-message').remove();
        $('.erawan-form .form-group, .erawan-form .form-row').removeClass('has-error');

        var formData = $(this).serializeArray();
        formData.push({ name: 'action', value: 'registration' });
        formData.push({ name: 'security', value: erawanRegistration.nonce });

        $.ajax({
            url: erawanRegistration.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: formData,
            success: function (response) {
                if (response.success) {
                    $('.message-container').html(
                        '<div class="success-message">' + response.data.message + '</div>'
                    );
                    window.location.href = response.data.redirect;
                }
            },
            error: function (xhr) {
                if (xhr.responseJSON && xhr.responseJSON.data) {
                    var errors = xhr.responseJSON.data;
                    Object.keys(errors).forEach(function (fieldName) {
                        var $field = $('[name="' + fieldName + '"]');
                        if ($field.length > 0) {
                            var $formGroup = $field.closest('.form-group, .form-row');
                            $formGroup.addClass('has-error');
                            $formGroup.append(
                                '<div class="error-message">' + errors[fieldName] + '</div>'
                            );
                        }
                    });
                }
            },
        });
    });

    console.log('jQuery is ready!');

    if (typeof wc_password_strength_meter !== 'undefined') {
        var $pwdInput = $('#erawan-registration-form input[name="password"]');
        console.log('$pwdInput:', $pwdInput);
        if ($pwdInput.length) {
            $pwdInput.on('input', function () {
                var strengthValue = wc_password_strength_meter.readability($(this).val());

                console.log('Jelszó erőssége:', strengthValue);
            });
        }
    }
});
